import { css } from '@emotion/react';

import { theme } from './theme';

const styles = {
  button: css`
    color: ${theme.colors.link};
    text-transform: none;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: ${theme.colors.linkHover};
    }

    &:focus {
      box-shadow: none;
      text-decoration: underline;
    }
  `,
};

export const LinkButton = ({ className, ...props }: JSX.IntrinsicElements['button']) => {
  return <button css={styles.button} className={`reset ${className}`} {...props} />;
};
